<span title="Filter Column" [inlineSVG]="'assets/media/svg/icons/humber-white.svg'" cacheSVG="true" class="svg-icon svg-icon-md pointer-event column-selection-icon"></span>
